import { request } from './api';

/**
 * Settings → WhatsApp reminders: who gets the 08:00 message of what is due.
 * Owner only. A key is never read back — only its last four characters.
 */

export interface Recipient {
  id: string;
  name: string;
  phone: string;
  keyEnd: string;
  lastSentAt: string | null;
  /** 'sent', or what TextMeBot said when it was not. */
  lastResult: string | null;
  rowVersion: number;
}

export interface RecipientInput {
  name: string;
  phone: string;
  /** Empty on an edit keeps the saved key. */
  apikey: string;
}

export const whatsappApi = {
  list: () => request<{ recipients: Recipient[] }>('/whatsapp/recipients'),

  add: (body: RecipientInput) => request<Recipient>('/whatsapp/recipients', { method: 'POST', body }),

  update: (id: string, body: RecipientInput & { rowVersion: number }) =>
    request<Recipient>(`/whatsapp/recipients/${id}`, { method: 'PATCH', body }),

  remove: (id: string) => request<void>(`/whatsapp/recipients/${id}`, { method: 'DELETE' }),

  test: (id: string) =>
    request<{ ok: boolean; result: string; recipient: Recipient }>(`/whatsapp/recipients/${id}/test`, { method: 'POST' }),
};
